const conflictingStaffIcon = () => {
  return (
    <>
   <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
  <g clipPath="url(#clip0_590_7351)">
    <mask id="mask0_590_7351" mask-type="luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48">
      <path d="M48 0H0V48H48V0Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_590_7351)">
      <path d="M39 48H9C4.02905 48 0 43.9709 0 39V9C0 4.02905 4.02905 0 9 0H39C43.9709 0 48 4.02905 48 9V39C48 43.9709 43.9709 48 39 48Z" fill="#FFF1F0"/>
      <path d="M34.2495 29.2495H33.999V27.7495C33.999 26.3711 32.877 25.249 31.4985 25.249C30.1201 25.249 28.998 26.3711 28.998 27.7495V29.2495H28.7476C27.7844 29.2495 27 30.0339 27 31V34.4995C27 35.4641 27.7844 36.25 28.7505 36.25H34.251C35.2156 36.25 36 35.4641 36 34.4995V31C36 30.0339 35.2156 29.2495 34.2495 29.2495ZM30.4995 27.7495C30.4995 27.1976 30.9481 26.749 31.5 26.749C32.0519 26.749 32.5005 27.1976 32.5005 27.7495V29.2495H30.501V27.7495H30.4995Z" fill="#FF8585"/>
      <path d="M25.5 31C25.5 29.6501 26.3265 28.4904 27.4995 28V27.7495C27.4995 27.142 27.6464 26.5707 27.8895 26.0547C27.1337 25.5475 26.2258 25.249 25.2495 25.249H16.749C14.1313 25.249 12 27.3804 12 29.9995V33.499C12 33.9128 12.3362 34.249 12.75 34.249H25.5V31Z" fill="#E62D38"/>
      <path d="M25.9995 18.2505C25.9995 21.0117 23.7612 23.25 21 23.25C18.2388 23.25 16.0005 21.0117 16.0005 18.2505C16.0005 15.4893 18.2388 13.251 21 13.251C23.7612 13.251 25.9995 15.4893 25.9995 18.2505Z" fill="#E62D38"/>
    </g>
  </g>
  <defs>
    <clipPath id="clip0_590_7351">
      <rect width="48" height="48" fill="white"/>
    </clipPath>
  </defs>
</svg>
    </>
  );
};
export default conflictingStaffIcon;
